// tslint:disable
export var TCSCommunicationType;
(function (TCSCommunicationType) {
    // None
    TCSCommunicationType[TCSCommunicationType["None"] = 0] = "None";
    // Letter
    TCSCommunicationType[TCSCommunicationType["Letter"] = 1] = "Letter";
    // Email
    TCSCommunicationType[TCSCommunicationType["Email"] = 2] = "Email";
    // SMS
    TCSCommunicationType[TCSCommunicationType["SMS"] = 4] = "SMS";
    // Phone
    TCSCommunicationType[TCSCommunicationType["Phone"] = 8] = "Phone";
    // Fax
    TCSCommunicationType[TCSCommunicationType["Fax"] = 16] = "Fax";
})(TCSCommunicationType || (TCSCommunicationType = {}));
TCSCommunicationType['NONE'] = 0;
TCSCommunicationType['LETTER'] = 1;
TCSCommunicationType['EMAIL'] = 2;
TCSCommunicationType['PHONE'] = 8;
TCSCommunicationType['FAX'] = 16;
//# sourceMappingURL=TCSCommunicationType.js.map